// Types

export type MainStoreErrorState = Error | null | undefined;

export type SetErrorAction = {
  type: 'SET_ERROR';
  error: Error;
};

export type MainStoreErrorAction = SetErrorAction;

// Reducer

export function errorReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreErrorState = null,
  action: MainStoreErrorAction,
) {
  switch (action.type) {
    case 'SET_ERROR':
      return action.error;

    default:
      return state;
  }
}
